export default __webpack_public_path__ + "static/media/arrow-tilted.510f8256a234c949827a48b19a536d69.svg";